<script>
import axios from 'axios'
import moment from 'moment'
import CryptoJS from "crypto-js"

const name = 'zxc123';
let systemLogType = '0';

function copy(value){
  return JSON.parse(JSON.stringify(value))
}

function encrypt(word, keyStr, ivStr) {
  const KEY = CryptoJS.enc.Utf8.parse("78afc8512559b62f");
  const IV = CryptoJS.enc.Utf8.parse("1234567890123456");
  
  let key = KEY
  let iv = IV

  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }

  let srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  // console.log("-=-=-=-", encrypted.ciphertext)
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

function decrypt(word, keyStr, ivStr) {
  const KEY = CryptoJS.enc.Utf8.parse("78afc8512559b62f");
  const IV = CryptoJS.enc.Utf8.parse("1234567890123456");
  let key = KEY
  let iv = IV

  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }

  let base64 = CryptoJS.enc.Base64.parse(word);
  let src = CryptoJS.enc.Base64.stringify(base64);

  var decrypt = CryptoJS.AES.decrypt(src, key, {
    iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });

  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

function toCDB(value){
  var tmp = ""; 
  for(var i=0;i<value.length;i++){ 
    if (value.charCodeAt(i) == 12288){
      tmp += String.fromCharCode(value.charCodeAt(i)-12256);
      continue;
    }
    if(value.charCodeAt(i) > 65280 && value.charCodeAt(i) < 65375){ 
      tmp += String.fromCharCode(value.charCodeAt(i)-65248); 
    } 
    else{ 
      tmp += String.fromCharCode(value.charCodeAt(i)); 
    } 
  }
  return tmp 
}

function jsonConcat(o1, o2){
  for (var key in o2) {
    o1[key] = o2[key];
  }
  return o1;
}

function checkForm(list, requiredField){
  let result = true
  for(var key of requiredField){
    if(!list[key]){
      result = false
    }
  }
  return result
}

function getTypevDescription(list, value){
  var index = list.findIndex(function(item){return item.valuev == value})
  return (index != -1) ? list[index].title : null
}

function getZipCode(list, value, valueDefault = null){
  var index = list.findIndex(function(item){return item.area == value})
  return (index != -1) ? list[index].zipCode : valueDefault
}

function getExamFee(list, value, feeType){
  let res
  var index = list.findIndex(function(item){return item.class3 == value})
  if(index != -1){
    switch(feeType){
      case '1': //'原價'
        res = list[index].originalPrice
        break
      case '2': //'專案認證價'
        res = list[index].projectPrice
        break
      case '3': //'減免價'
        res = list[index].reducedPrice
        break
      case '4': //'教師價'
        res = list[index].teacherPrice
        break
      case '5': //'其他'
        res = list[index].otherPrice
        break
    }
  }
  return res
}

function getHavePay(list, value, examMemberType){
  let res
  var index = list.findIndex(function(item){return item.class3 == value})
  if(index != -1){
    switch(examMemberType){
      case '3': //'老師'
        res = list[index].teacherPrice
        break
      case '4': //'身心障礙'
      case '5': //'低收入戶'
        res = list[index].reducedPrice
        break
      case '6': //'其他'
        res = list[index].otherPrice
        break
    }
  }
  return res
}

function getApplyFee(list = null, value = null, applyItem, examTime = null){
  let res
  let time
  if(examTime){
    time = examTime
  } else {
    var index = list.findIndex(function(item){return item.class3 == value})
    if(index != -1){
      time = list[index].examTime
    }
  }
  switch(applyItem){
    case '0':
      res = '500'
      break
    case '1':
      res = '300'
      break
    case '2':
      res = (time == '60') ? '300' : '500'
      break
    case '3':
      res = (time == '60') ? '800' : '1000'
      break
    case '4':
      res = (time == '60') ? '600' : '800'
      break
    case '5':
      res = (time == '60') ? '1100' : '1300'
      break
    default:
      break
  }
  return res
}

async function getNowTime(){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/getNowTime',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getPrecautions(){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/erpExamWatchByExamType/precautions',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getMemberTeacher(){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/erpExamWatchByExamType/memberTeacher',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getPaymentDeadline(value){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/getPaymentDeadline/' + value,
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data
    }).catch(()=>{
    }).finally(()=>{
      if( new Date(res) < new Date() ){
        res = moment().format('YYYY-MM-DD')
      }
    })
  return res
}

async function checkIdCard(value){
  let res
  var request = {
    method: 'POST',
    url: '/common/checkIdCard',
    params: {
      IdCard: value,
    }
  }
  await axios(request)
    .then(function(response) {
      console.log("[checkIdCard] " + response.data.isIdCardVaild)
      if(response.data.isIdCardVaild == 'Success'){
        res = true
      } else {
        res = false
      }
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getIdCardInfo(value){
  let res
  var request = {
    method: 'POST',
    url: '/common/checkIdCard',
    params: {
      IdCard: value,
    }
  }
  await axios(request)
    .then(function(response) {
      res = response.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function checkChinaIdCard(value){
  let res
  var request = {
    method: 'POST',
    url: '/common/checkChinaIdCard',
    params: {
      // IdCard: value,
      card: value,
    }
  }
  await axios(request)
    .then(function(response) {
      console.log("[checkChinaIdCard] " + response.data.isIdCardVaild)
      if(response.data.isIdCardVaild == 'Success'){
        res = true
      } else {
        res = false
      }
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function checkPassport(value){
  let res
  var request = {
    method: 'POST',
    url: '/common/checkPassport',
    params: {
      // IdCard: value,
      card: value,
    }
  }
  await axios(request)
    .then(function(response) {
      console.log("[checkPassport] " + response.data.isIdCardVaild)
      if(response.data.isIdCardVaild == 'Success'){
        res = true
      } else {
        res = false
      }
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getCountryList(){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/countryList',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      // console.log("[Global] response: " + response)
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getSystemLog(){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/typevByCategory/systemLogApply',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      systemLogType = response.data.data[0].title
      console.log('[Global][getSystemLog]systemLogType: ' + systemLogType)
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function setSystemLog(ipAddress,userId,type,examNo,logContent,note1,note2=null,note3=null){
  if(systemLogType == '0'){
    return
  }
  let res = []
  var request = {
    method: 'POST',
    url: '/common/systemLog',
    params: {
      ipAddress: ipAddress,
      userId: userId,
      system: '1',
      type: type,
      examNo: examNo,
      logContent: logContent,
      note1: note1,
      note2: note2,
      note3: note3,
    },
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
      // console.log('[Global][setSystemLog]res: ' + res)
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getFrontendAreaList(){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/typevByCategory/frontendArea',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getExamLimitList(){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/typevByCategory/examLimit',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getPayStatusList(){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/typevByCategory/payStatus',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getApplyItemList(){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/typevByCategory/applyItem',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getExamMethodList(){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/typevByCategory/examMethod',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getFeeTypeList(){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/typevByCategory/feeType',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getBillboard(){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/typevByCategory/billboard',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data[0]
      console.log('res: ' + res)

    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getMemberTypeList(){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/typevByCategory/memberType',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getCollegeCategoryList(){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/typevByCategory/collegeCategory',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getSchoolList(value, value1){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/collegeListByCategory/' + value,
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
      if(value1){
        let tmp = res
        res = []
        for(var i=0; i<tmp.length; i++) {
          // console.log('[tmp[i].name]: ' +  tmp[i].name)
          if(!tmp[i].name.includes('大型會考'))
          res.push(tmp[i])
        }
      }
    })
  return res
}

async function getMailCandidateList(){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/typevByCategory/mailBoxSelect',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      var tmp = response.data.data
      for(var i=0; i<tmp.length; i++) {
        res.push(tmp[i].title)
      }
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getCitizenShipList(){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/typevByCategory/citizenShip',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getCollegeAreaListByCategoryList(value){
  let res = []
  var request = {
    method: 'GET',
    url: '/collegeAreaListByCategory/' + value,
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getAreaListByCountryList(value){
  let res = []
  var request = {
    method: 'POST',
    url: '/common/areaListByCountry/' + value,
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getClassItemManufacturerList(){
  let res = []
  var request = {
    method: 'GET',
    url: '/classItemManufacturerList',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getClassItemClass1ManufacturerList(value){
  let res = []
  var request = {
    method: 'GET',
    url: '/classItemClass1List/' + value,
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getClassItemClass1List(){
  let res = []
  var request = {
    method: 'GET',
    url: '/classItemClass1List',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getClassItemClass2List(value){
  let res = []
  var request = {
    method: 'GET',
    url: '/classItemClass2List/' + value,
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getClassItemClass3List(value, value1){
  if(!value1){
    return
  }
  let res = []
  var request = {
    method: 'GET',
    url: '/common/classItemClass3List/' + value + '/' + value1,
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getErpComeMoDrillDownList(){
  let res = []
  var request = {
    method: 'GET',
    url: '/erpComeMoDrillDown',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getCollegeListByCategoryAndCountryList(value, value1, value2){
  if(!value1){
    return []
  }
  let res = []
  var request = {
    method: 'GET',
    url: '/collegeListByCategoryAndCountry/' + value + '/' + value1,
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
      if(value2){
        let tmp = res
        res = []
        for(var i=0; i<tmp.length; i++) {
          // console.log('[tmp[i].name]: ' +  tmp[i].name)
          if(!tmp[i].name.includes('大型會考'))
          res.push(tmp[i])
        }
      }
    })
  return res
}

async function getExamStaffListDrillDownList(){
  let res = []
  var request = {
    method: 'GET',
    url: '/examStaffListDrillDown',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getCertificatePaymentDeadline(){
  let res = []
  var request = {
    method: 'GET',
    url: '/getCertificatePaymentDeadline',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getApplyStatusList(){
  return [
    {valuev: '1', title:'報名中'},
    {valuev: '2', title:'場次確認'},
    {valuev: '3', title:'場次取消'},
    {valuev: '4', title:'截止報名'}
  ]
}

async function getHiTrustStoreList(){
  return [
    {type: '信用卡', storeid:'50934'},
    {type: '虛擬帳號', storeid:'15090'},
    {type: 'LINE Pay', storeid:'LT032'},
    {type: '銀聯卡', storeid:'62520'}
  ]
}

async function getHiTrustServiceList(){
  return [
    {type: '服務器地址', url:'TODO_FORM_ACTION'},
    {type: 'returnURL', url:'https://register.cerps.org.tw/Apply/#/registerInformationList'},
    {type: 'merUpdateURL', url:'https://exam.cerps.org.tw/study-0.0.1-SNAPSHOT/common/wiCcRecord'}
  ]
}

async function getHiTrustServiceListProject(){
  return [
    {type: '服務器地址', url:'TODO_FORM_ACTION'},
    {type: 'returnURL', url:'https://register.cerps.org.tw/Apply/#/projectList'},
    {type: 'merUpdateURL', url:'https://exam.cerps.org.tw/study-0.0.1-SNAPSHOT/common/wiCcRecord'}
  ]
}

export default
{
  name, //this.$Global.name
  systemLogType, //控制systemLog表 1-啟用/0-未啟用

  //
  copy,
  encrypt,
  decrypt,
  toCDB,
  jsonConcat,
  checkForm,
  getTypevDescription,

  //
  getZipCode,
  getExamFee,
  getHavePay,
  getApplyFee,

  //[API]
  getNowTime,
  getPrecautions,
  getMemberTeacher,
  getPaymentDeadline,
  checkIdCard,
  getIdCardInfo,
  checkChinaIdCard,
  checkPassport,

  //[API]
  getCountryList,
  getSystemLog,
  setSystemLog,
  getFrontendAreaList,
  getExamLimitList,
  getPayStatusList,
  getApplyItemList,
  getExamMethodList,
  getFeeTypeList,
  getBillboard,
  getMemberTypeList,
  getCollegeCategoryList,
  getSchoolList,
  getMailCandidateList,
  getCitizenShipList,
  getCollegeAreaListByCategoryList,
  getAreaListByCountryList,
  getClassItemManufacturerList,
  getClassItemClass1ManufacturerList,
  getClassItemClass1List,
  getClassItemClass2List,
  getClassItemClass3List,
  getErpComeMoDrillDownList,
  getCollegeListByCategoryAndCountryList,
  getExamStaffListDrillDownList,
  getCertificatePaymentDeadline,

  //
  getApplyStatusList,
  getHiTrustStoreList,
  getHiTrustServiceList,
  getHiTrustServiceListProject
}
</script>